import React from 'react'

type CancelledOrderTabIconProps = {
  testId?: string
}

export function CancelledOrderTabIcon({ testId }: CancelledOrderTabIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      data-testid={testId}
    >
      <path
        d="M9.58333 18.6L8.4 17.4167L10.8334 15L8.4 12.5833L9.58333 11.4L12 13.8334L14.4167 11.4L15.6 12.5833L13.1667 15L15.6 17.4167L14.4167 18.6L12 16.1667L9.58333 18.6ZM4.66665 22C4.21665 22 3.82637 21.8347 3.49582 21.5042C3.16527 21.1736 3 20.7834 3 20.3334V5.33333C3 4.88333 3.16527 4.49305 3.49582 4.1625C3.82637 3.83193 4.21665 3.66665 4.66665 3.66665H6.08332V2H7.83333V3.66665H16.1667V2H17.9167V3.66665H19.3333C19.7833 3.66665 20.1736 3.83193 20.5042 4.1625C20.8347 4.49305 21 4.88333 21 5.33333V20.3334C21 20.7834 20.8347 21.1736 20.5042 21.5042C20.1736 21.8347 19.7833 22 19.3333 22H4.66665ZM4.66665 20.3334H19.3333V9.83333H4.66665V20.3334ZM4.66665 8.16668H19.3333V5.33333H4.66665V8.16668Z"
        fill="currentColor"
      />
    </svg>
  )
}
